import { AppModal } from "./AppModal";

export const ResetSessionModal = ({
  isOpen,
  onOpenChange,
  isLoading = false,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="New Session"
      description="Are you sure you want to reset your current session?"
      confirmButtonText="New Session"
      cancelButtonText="Cancel"
      isLoading={isLoading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
